import { filter } from "lodash";
import { apiCall } from "./authServices";

const filterArrayMap = {
  ho: ["Region", "Zone", "Area", "Dealer"],
  rm: ["Zone", "Area", "Dealer"],
  zm: ["Area", "Dealer"],
  default: [],
};

export const UpdateReportList = (userRoleType) => {
  const filterArray = filterArrayMap[userRoleType] || filterArrayMap.default;

  const reportList = [
    { label: "MVR Overview", apiString: "api/reports/mvr-overview-report", filter: ['ho', 'zm', 'rm', 'am'], showFilter: true },
    { label: "MVR Aggregate Report", apiString: "api/reports/mvr-aggregate-report", filter: ['ho', 'zm', 'rm', 'am'], showFilter: true },
    { label: "MVR Mom Aggregate Report", apiString: "api/reports/mvr-mom-aggregate-report", filter: ['ho', 'zm', 'rm', 'am'], showFilter: true},
    { label: "MVR Plan VS Actual", apiString: "api/reports/mvr-plan-vs-actual-report", filter: ['ho', 'zm', 'rm', 'am']},
    { label: "MVR Evaluation Status Report", apiString: "api/reports/mvr-evaluation-status-report", filter: ['ho', 'zm', 'rm', 'am', 'dealer'], },
    { label: "MVR Visit Report", apiString: "api/reports/mvr-visit-report", filter: ['ho', 'zm', 'rm', 'am', 'dealer'] },
    // { label: "MVR MoM Status Report", apiString: "api/reports/mvr-mom-status-report", filter: ['ho', 'zm', 'rm', 'am', 'dealer'] },
    { label: "MoM Escalation Report", apiString: "api/reports/mvr-mom-escalation-report", filter: ['ho', 'zm', 'rm', 'am', 'dealer'] },
    { label: "Top 10 Dealers", apiString: "api/reports/mvr-top-dealers-report", filter: ['ho'] }
  ];

  const updatedReportList = reportList.map(report => ({
    ...report,
    filterList: filterArray,
    showTab: report.filter.includes(userRoleType)
  }));

  return updatedReportList.filter(report => report.showTab);
};


export const GetExcelFile = async ({ selectedTab, payload }) => {
  try {
    const res = await apiCall({
      endpoint: selectedTab.apiString,
      method: "POST",
      payload: payload,
    });

    return res;
  } catch (error) {
    throw error;
  }
};
